package com.kanati.admin.state

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.CancellationException

/** A screen-owned read. Old results are discarded before refresh, including failed refreshes. */
class ReadState<T> {
    var value by mutableStateOf<T?>(null)
        private set
    var loading by mutableStateOf(true)
        private set
    var error by mutableStateOf<String?>(null)
        private set

    suspend fun refresh(failureMessage: String, read: suspend () -> T) {
        value = null
        error = null
        loading = true
        try {
            value = read()
        } catch (cancelled: CancellationException) {
            throw cancelled
        } catch (_: Exception) {
            error = failureMessage
        } finally {
            loading = false
        }
    }
}
